import React from "react";
import { Slide } from "react-reveal";
import road from "../../assets/images/content1/3.png";
import struct from "../../assets/images/hero/3.jpg";
import build from "../../assets/images/content1/6.png";
import proj from "../../assets/images/hero/2.jpg";
import HighlightCard from "../reusables/HighlightCard";

const ServicesList = () => {
  return (
    <Slide left>
      <ul className="hightlights-container flex">
        <HighlightCard
          img={road}
          link="/projects"
          title="CIVIL WORKS"
        ></HighlightCard>
        <HighlightCard
          img={struct}
          link="/projects"
          title="STRUCTURAL WORKS"
        ></HighlightCard>
        <HighlightCard
          img={build}
          link="/projects"
          title="BUILDING WORKS"
        ></HighlightCard>
        <HighlightCard
          img={proj}
          link="/projects"
          title="PROJECT MANAGEMENT"
        ></HighlightCard>
      </ul>
    </Slide>
  );
};

export default ServicesList;
